export const SETTINGS_PAGE_TITLE = "Account Settings";
export const SETTINGS_MEMBER_ROLE_CHIP = "Member";
export const SETTINGS_ADMIN_ROLE_CHIP = "Admin";
